<template>
    <div>
        <a-drawer
                :title='title'
                :visible="visibleJurisdiction"
                v-bind="drawerConfig"
                :body-style="{ paddingBottom: '80px' }"
                @close="onClose"
        >
            <a-checkbox v-model="checkAll" @change="handleCheckAllChange">
                全选
            </a-checkbox>
        <a-tree
                v-model="checkedKeys"
                checkable
                :expanded-keys="expandedKeys"
                :auto-expand-parent="autoExpandParent"
                :selected-keys="selectedKeys"
                :replaceFields="replaceFields"
                :tree-data="treeData"
                @expand="onExpand"
                @check="onCheck"
        />
            <div class="drawer-btn"  >

                <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                    确定
                </a-button>
                <a-button @click="onClose">
                取消
            </a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import API from "../api";
    import {submitForm,drawerConfig} from "../../../../utils/utils"

    export default {
        name: "jurisdictionForm",
        props:["visibleJurisdiction","title","jurisdictionId"],
        data(){
            return{
                checkAll: false,
                CheckTree:false,
                replaceFields:{children:'children', title:'name', key:'id'},
                firstIds:[],
                expandedKeys: [ ],
                autoExpandParent:true,
                checkedKeys: [ ],
                selectedKeys: [],
                treeData:[],
                num:0,
                fnum:0,
                drawerConfig:drawerConfig,
                ids:[],
                idsArr:[],
                form:{
                    ids:"",
                }
            }
        },
        watch:{
            checkedKeys(val) {
                this.form.ids=val
            },
            jurisdictionId: function (a, b) {
                if (a != "") {
                    // 切换不同版本时，先清空上一次的缓存，避免 firstIds/idsArr/ids/checkedKeys 残留污染本次提交
                    this.checkAll= false
                    this.CheckTree=false
                    this.firstIds=[]
                    this.ids=[]
                    this.idsArr=[]
                    this.checkedKeys=[]
                    this.num=0
                    this.fnum=0
                    API.versionManagement. GET_JURISDICTION(a).then(res => {
                        this.treeData = res.data.data
                        this.getfouc(res.data.data)
                        this.form.a_version_id=a
                        if(this.checkedKeys.length+this.fnum==this.ids.length ){this.checkAll=true }
                    })
                } else {
                    this.form.a_version_id = ''
                }
            }
        },
        methods:{
            handleCheckAllChange(val) {
                if (this.checkAll) {
                    this.checkedKeys=this.ids
                    this.idsArr=[...this.ids]
                } else {
                    this.checkedKeys=[]
                    this.idsArr=[]
                }
                // 全选操作也算手动改动树，需标记 CheckTree，否则 onSubmit 会走 firstIds 旧数据分支
                this.CheckTree=true
            } ,
            getfouc(list) {
                list.map((value, key, arr) => {
                    if (value.children) {
                        this.fnum++
                        this.ids.push(value.id)
                        this.getfouc(value.children)
                      if (value.is_check == 1) {
                        this.firstIds.push(value.id)
                      }
                    } else {
                        this.num++
                        this.ids.push(value.id)
                        if (value.is_check == 1) {
                            this.checkedKeys.push(value.id)
                            this.idsArr.push(value.id)
                            this.firstIds.push(value.id)
                        }
                    }

                })
            },
            onExpand(expandedKeys) {
                this.expandedKeys = expandedKeys;
                this.autoExpandParent = false;

            },
            onCheck(checkedKeys,e) {
              console.log("********************",checkedKeys)
              console.log("**********///**********",e.halfCheckedKeys)
                this.CheckTree=true
                // idsArr 只存已选中节点，不存半选父节点。否则后端会把半选父节点展开为全部子权限，导致保存了所有权限
                this.idsArr=[...checkedKeys]
                this.checkedKeys = checkedKeys;
                if (this.checkedKeys.length == this.ids.length) {
                    this.checkAll = true
                } else {
                    this.checkAll = false
                }
            },
            onSelect(selectedKeys, info) {
                this.selectedKeys = selectedKeys;
            },
            onClose() {
                this.checkAll= false
                this.selectedKeys=[]
                this.checkedKeys=[]
                this.num=0
                this.fnum=0
                this.ids=[]
                this.idsArr=[]
              this.CheckTree=false,
                this.$emit("changVisible", false);
            },
            onSubmit() {
                let _this = this;
                console.log("----",this.firstIds)
              if(this.CheckTree){
                if(this.checkAll==true) {
                  this.form.ids=this.ids
                } else{
                  this.checkedKeys.length<1? this.form.ids=[]:this.form.ids=this.idsArr
                }
              }else{
                this.form.ids=Array.from(new Set(this.firstIds))
              }
              console.log("----",this.form)
                        submitForm(API.versionManagement.SUBMIT_JURISDICTION, this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                            }
                        })
            },
        },

    }
</script>

<style scoped>

</style>
